/* eslint-disable no-underscore-dangle */
// tslint:disable: completed-docs

import { Applicant } from './applicant.class';
import { JointCreditManager } from './joint-credit-manager.class';

/**
 * A class represent the joint applicant in pair. The relation will be Applicant -> Parent which means the applicant is joint with parent
 * The primary applicant is always the parent
 * The parent applicant will be always primary
 */
export class JointApplicant {
  private _selectedApplicant?: Applicant;
  private _selectedParent?: Applicant;

  private _applicant?: Applicant;
  private _parent?: Applicant;

  public get unSelectedApplicantsForApplicant(): Applicant[] {
    return this.manager.allApplicants.filter((a) => !Applicant.areSame(a, this._selectedParent) && this.canBeSelectedForApplicant(a));
  }

  public get unSelectedApplicantsForParents(): Applicant[] {
    return this.manager.allApplicants.filter((a) => !Applicant.areSame(a, this._selectedApplicant) && this.canBeSelectedForParent(a));
  }

  public get applicant(): Applicant {
    return this._applicant ? this._applicant : null;
  }

  public set applicant(applicant: Applicant) {
    this._selectedApplicant = applicant;

    if (Applicant.areSame(this._parent, applicant)) {
      return;
    }

    if (!applicant || this._applicant !== applicant) {
      this.removeJoint();
    }

    this._applicant = applicant;
    this.updateJoint();
  }

  public get parent(): Applicant {
    return this._parent ? this._parent : null;
  }

  public set parent(parent: Applicant) {
    this._selectedParent = parent;

    if (Applicant.areSame(this._applicant, parent)) {
      return;
    }

    if (!parent || this._parent !== parent) {
      this.removeJoint();
    }

    this._parent = parent;
    this.updateJoint();
  }

  public get areParentAndApplicantSame(): boolean {
    return Applicant.areSame(this._selectedApplicant, this._selectedParent);
  }

  constructor(private readonly manager: JointCreditManager, parent?: Applicant, applicant?: Applicant) {
    this._parent = parent;
    this._selectedParent = parent;
    this._applicant = applicant;
    this._selectedApplicant = applicant;
  }

  private updateJoint(): void {
    if (this._parent && this._applicant) {
      // Make sure the main applicant doesn't have a parent
      if (this._applicant.isPrimaryApplicant) {
        this._applicant.removeParent();
        this._parent.setParent(this._applicant);
        this._applicant.setChild();
      } else {
        this._parent.removeParent();
        this._applicant.setParent(this._parent);
        this._parent.setChild();
      }
    }
  }

  private removeJoint(): void {
    if (this._parent) {
      this._parent.removeParent();
    }

    if (this._applicant) {
      this._applicant.removeParent();
    }
  }

  private canBeSelectedForApplicant(applicant: Applicant): boolean {
    return Applicant.areSame(this.applicant, applicant) || !this.manager.isJoint(applicant);
  }

  private canBeSelectedForParent(applicant: Applicant): boolean {
    return Applicant.areSame(this.parent, applicant) || !this.manager.isJoint(applicant);
  }
}
